import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ListGroup } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import Pagination from '../../components/_Pagination';
import Loading from './Loading';
import ChatItem from './ChatItem';
import StartChat from './StartChat';
import { loadChats } from '../../actions/chats';

const mapStateToProps = ({ chats }) => ({
  page: chats.page,
  itemsPerPage: chats.itemsPerPage,
  list: chats.list,
  count: chats.count,
  isLoaded: chats.isLoaded,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  loadContent: loadChats,
}, dispatch);

class Chats extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      redirectToChat: 0,
    };
  }

  componentDidMount() {
    const { page, loadContent } = this.props;
    loadContent(page);
  }

  render() {
    const { redirectToChat } = this.state;
    if (redirectToChat) {
      return <Redirect to={`/trainings/chats/${redirectToChat}`} />;
    }

    const { page, itemsPerPage, list, count, isLoaded, loadContent } = this.props;

    return (
      <div style={{ position: 'relative' }}>
        <StartChat
          actionType="add"
          onAddComplete={id => this.setState({ redirectToChat: id })}
        />
        {!isLoaded && <Loading />}{list && (
        <React.Fragment>
          <ListGroup>{list.map(item => <ChatItem key={item.id} {...item} />)}</ListGroup>
          <div className="chat_pagination">
            <Pagination
              activePage={page}
              itemsPerPage={itemsPerPage}
              totalItems={count}
              onChange={loadContent}
            />
          </div>
        </React.Fragment>)}
      </div>
    );
  }
}

Chats.propTypes = {
  page: PropTypes.number,
  itemsPerPage: PropTypes.number,
  list: PropTypes.arrayOf(PropTypes.any),
  count: PropTypes.number,
  isLoaded: PropTypes.bool,
  loadContent: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Chats);



// WEBPACK FOOTER //
// ./src/views/_Chats/index.js